
export const messages = {
  en: {
    inspectionTaskDetails: {
      searchCondition: 'Search Condition',
      more: 'More',
      hide: 'Hide',
      inputInspector: 'Please enter inspector',
      inputStartTime: 'Please enter actual inspection start time',
      inputEndTime: 'Please enter actual inspection end time',
      search: 'Search',
      reset: 'Reset',
      selectInspectionPlan: 'Please select inspection plan',
      selectInspectionRoute: 'Please select inspection route',
      selectInspectionPoint: 'Please select inspection point',
      inputTaskDetailId: 'Please enter task detail ID',
      selectSignStatus: 'Please select sign status',
      selectInspectionPointStatus: 'Please select inspection point status',
      selectTaskStatus: 'Please select task status',
      selectPatrolStatus: 'Please select patrol status',
      inspectionDetails: 'Inspection Details',
      export: 'Export',
      taskDetailId: 'Task Detail ID',
      inspectionPointName: 'Inspection Point Name',
      inspectionPlanName: 'Inspection Plan Name',
      inspectionRouteName: 'Inspection Route Name',
      inspector: 'Inspector',
      startEndTime: 'Start/End Time',
      inspectionPoint: 'Inspection Point',
      actualInspectionTime: 'Actual Inspection Time',
      actualSignStatus: 'Actual Sign Status',
      plannedInspector: 'Planned Inspector',
      actualInspector: 'Actual Inspector',
      inspectionMethod: 'Inspection Method',
      taskStatus: 'Task Status',
      inspectionPointStatus: 'Inspection Point Status',
      patrolStatus: 'Patrol Status',
      inspectionPhotos: 'Inspection Photos',
      createTime: 'Create Time',
      locationInfo: 'Location Info',
      view: 'View'
    }
  },
  zh: {
    inspectionTaskDetails: {
      searchCondition: '查询条件',
      more: '更多',
      hide: '隐藏',
      inputInspector: '请输入巡检人',
      inputStartTime: '请输入实际巡检开始时间',
      inputEndTime: '请输入实际巡检结束时间',
      search: '查询',
      reset: '重置',
      selectInspectionPlan: '请选择巡检计划',
      selectInspectionRoute: '请选择巡检路线',
      selectInspectionPoint: '请选择巡检点',
      inputTaskDetailId: '请输入任务详情ID',
      selectSignStatus: '请选择签到状态',
      selectInspectionPointStatus: '请选择巡检点状态',
      selectTaskStatus: '请选择任务状态',
      selectPatrolStatus: '请选择巡检情况',
      inspectionDetails: '巡检明细',
      export: '导出',
      taskDetailId: '任务详情ID',
      inspectionPointName: '巡检点名称',
      inspectionPlanName: '巡检计划名称',
      inspectionRouteName: '巡检路线名称',
      inspector: '巡检人',
      startEndTime: '开始/结束时间',
      inspectionPoint: '巡检点',
      actualInspectionTime: '实际巡检时间',
      actualSignStatus: '实际签到状态',
      plannedInspector: '计划巡检人',
      actualInspector: '实际巡检人',
      inspectionMethod: '巡检方式',
      taskStatus: '任务状态',
      inspectionPointStatus: '巡检点状态',
      patrolStatus: '巡检情况',
      inspectionPhotos: '巡检照片',
      createTime: '创建时间',
      locationInfo: '位置信息',
view: '查看'
    }
  },
  'zh-TW': {
    inspectionTaskDetails: {
      searchCondition: '查詢條件',
      more: '更多',
      hide: '隱藏',
      inputInspector: '請輸入巡檢人',
      inputStartTime: '請輸入實際巡檢開始時間',
      inputEndTime: '請輸入實際巡檢結束時間',
      search: '查詢',
      reset: '重設',
      selectInspectionPlan: '請選擇巡檢計劃',
      selectInspectionRoute: '請選擇巡檢路線',
      selectInspectionPoint: '請選擇巡檢點',
      inputTaskDetailId: '請輸入任務詳情ID',
      selectSignStatus: '請選擇簽到狀態',
      selectInspectionPointStatus: '請選擇巡檢點狀態',
      selectTaskStatus: '請選擇任務狀態',
      selectPatrolStatus: '請選擇巡檢情況',
      inspectionDetails: '巡檢明細',
      export: '導出',
      taskDetailId: '任務詳情ID',
      inspectionPointName: '巡檢點名稱',
      inspectionPlanName: '巡檢計劃名稱',
      inspectionRouteName: '巡檢路線名稱',
      inspector: '巡檢人',
      startEndTime: '開始/結束時間',
      inspectionPoint: '巡檢點',
      actualInspectionTime: '實際巡檢時間',
      actualSignStatus: '實際簽到狀態',
      plannedInspector: '計劃巡檢人',
      actualInspector: '實際巡檢人',
      inspectionMethod: '巡檢方式',
      taskStatus: '任務狀態',
      inspectionPointStatus: '巡檢點狀態',
      patrolStatus: '巡檢情況',
      inspectionPhotos: '巡檢照片',
      createTime: '創建時間',
      locationInfo: '位置信息',
      view: '查看'
    }
  }
}